module.exports = __webpack_public_path__ + "static/media/skylder.67ef88e6.mp3";